import _classCallCheck from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/createClass";
import TaggedLineSegment from './TaggedLineSegment';
import ArrayList from '../../../../java/util/ArrayList';
var TaggedLineString = /*#__PURE__*/function () {
  function TaggedLineString() {
    _classCallCheck(this, TaggedLineString);
    TaggedLineString.constructor_.apply(this, arguments);
  }
  _createClass(TaggedLineString, [{
    key: "addToResult",
    value: function addToResult(seg) {
      this._resultSegs.add(seg);
    }
  }, {
    key: "asLineString",
    value: function asLineString() {
      return this._parentLine.getFactory().createLineString(TaggedLineString.extractCoordinates(this._resultSegs));
    }
  }, {
    key: "getResultSize",
    value: function getResultSize() {
      var resultSegsSize = this._resultSegs.size();
      return resultSegsSize === 0 ? 0 : resultSegsSize + 1;
    }
  }, {
    key: "getParent",
    value: function getParent() {
      return this._parentLine;
    }
  }, {
    key: "getSegment",
    value: function getSegment(i) {
      return this._segs[i];
    }
  }, {
    key: "getParentCoordinates",
    value: function getParentCoordinates() {
      return this._parentLine.getCoordinates();
    }
  }, {
    key: "getMinimumSize",
    value: function getMinimumSize() {
      return this._minimumSize;
    }
  }, {
    key: "asLinearRing",
    value: function asLinearRing() {
      return this._parentLine.getFactory().createLinearRing(TaggedLineString.extractCoordinates(this._resultSegs));
    }
  }, {
    key: "getSegments",
    value: function getSegments() {
      return this._segs;
    }
  }, {
    key: "init",
    value: function init() {
      var pts = this._parentLine.getCoordinates();
      this._segs = new Array(pts.length - 1).fill(null);
      for (var i = 0; i < pts.length - 1; i++) {
        var seg = new TaggedLineSegment(pts[i], pts[i + 1], this._parentLine, i);
        this._segs[i] = seg;
      }
    }
  }, {
    key: "getResultCoordinates",
    value: function getResultCoordinates() {
      return TaggedLineString.extractCoordinates(this._resultSegs);
    }
  }], [{
    key: "constructor_",
    value: function constructor_() {
      this._parentLine = null;
      this._segs = null;
      this._resultSegs = new ArrayList();
      this._minimumSize = null;
      if (arguments.length === 1) {
        var parentLine = arguments[0];
        TaggedLineString.constructor_.call(this, parentLine, 2);
      } else if (arguments.length === 2) {
        var _parentLine = arguments[0],
          minimumSize = arguments[1];
        this._parentLine = _parentLine;
        this._minimumSize = minimumSize;
        this.init();
      }
    }
  }, {
    key: "extractCoordinates",
    value: function extractCoordinates(segs) {
      var pts = new Array(segs.size() + 1).fill(null);
      var seg = null;
      for (var i = 0; i < segs.size(); i++) {
        seg = segs.get(i);
        pts[i] = seg.p0;
      }
      pts[pts.length - 1] = seg.p1;
      return pts;
    }
  }]);
  return TaggedLineString;
}();
export { TaggedLineString as default };